
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import Loding from './loding.vue';

export default {
  components: { Loding },
  data() {
    return {
      token: '',
      chats: [],
      echo: null,
      sending: false,
      username: '123',
      message: '',
      focusOn: false,
      imageUrl: null,
      imageFiles: null,
      imageLoding: false,
      user: [],
      emoticon: [],
      emoticonList: [],
      swiperOptions: {
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
        },
      },
    };
  },

  methods: {
    handleBlur() {
      this.focusOn = false;
    },

    // 한글 칠때 한글자씩 빠는거
    change(e) {
      this.message = e.target.value;
    },

    locationClick() {
      alert('업데이트 예정입니다.');
      // this.$router.push('/chat/location')
      return;
    },

    // 쉬프트 엔터누르면 한줄 밑으로 가기
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        if (event.shiftKey) {
          // Shift+Enter 조합일 경우
          this.message += '\n';
          return;
        } else {
          this.send();
          this.message = '';
        }
      }
    },

    handleImageChange(event) {
      this.imageFiles = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(this.imageFiles);
      reader.onload = (e) => {
        this.imageUrl = e.target.result;
      };
      this.uploadImage();
      event.target.value = '';
    },

    uploadImage() {
      this.imageLoding = true;
      let form = new FormData();
      form.append('image', this.imageFiles);
      this.$axios
        .post('/api/posts/images', form)
        .then((response) => {
          this.imageFiles = response.data.data.original_url;
        })
        .then(async () => {
          this.imageLoding = false;
          const data = {
            username: this.$auth.user?.name,
            message: null,
            user_id: this.$auth.user?.id,
            name: this.$auth.user?.name,
            image: this.imageFiles,
            room_id: this.$route.query.groupId,
            profile:
              this.$auth.user?.img != null ? this.$auth.user?.img.url : null,
          };
          await this.$axios.post('/api/messages', data);
          this.imageFiles = null;
        });
    },

    async send() {
      if (this.$auth.user) {
        if (!this.sending) {
          const data = {
            username: this.$auth.user?.name,
            message: this.content,
            user_id: this.$auth.user?.id,
            name: this.$auth.user?.name,
            image: this.imageFiles,
            room_id: this.$route.query.groupId,
            profile:
              this.$auth.user?.img != null ? this.$auth.user?.img.url : null,
            alerts: null,
            message_position_id: this.messagePosition(
              this.$auth.user?.position
            ),
          };
          if (!this.validate(data)) {
            alert('입력을 확인해주세요!');

            return;
          }
          this.sending = true;
          this.message = '';
          this.imageUrl = null;
          this.imageFiles = null;
          this.$store.commit('setOption', false);
          this.$store.commit('setEmoticonOption', false);
          await this.$axios.post('/api/messages', data);
          this.sending = false;
        }
      } else {
        alert('로그인을 해주세요.');
        this.$router.push('/chat/login');
      }
    },
    validate(data) {
      if (data.username === '') return false;
      if (data.message === '' && data.image === null) return false;
      return true;
    },
    onChatSent(event) {
      this.chats.push(event);
      this.$emit('messageSubmit', this.chats);
      this.chats = [];
    },
    deleteChat(e) {
      this.$emit('messageDelete', e);
    },
    connect() {
      if (!window.Pusher) window.Pusher = Pusher;
      if (!this.echo) {
        this.echo = new Echo({
          broadcaster: 'pusher',
          key: '668bac10cc6db3a1338c',
          cluster: 'ap3',
          authEndpoint: '/api/broadcasting/auth',
        });
      }
      this.echo
        .channel(`chats` + this.$route.query.groupId)
        .listen('JoinMessage', (e) => {
          if (e.group.message_type == 0) {
            this.onChatSent(e);
          } else if (e.group.message_type == 1) {
            this.deleteChat(e);
          }
        });
      this.echo.channel('page-views').listen('PageViewed', (e) => {
        this.$emit('countSubmit', e);
      });
    },
    disconnect() {
      this.echo.leaveChannel(`chats` + this.$route.query.groupId);
      this.echo.leaveChannel(`page-views`);
    },

    documentOption(e) {
      let el2 = this.$refs.chatRef;
      let target = e.target;
      if (!el2.contains(target)) {
        this.$store.commit('setOption', false);
        this.$store.commit('setEmoticonOption', false);
      }
    },
    oneClick() {},
    // 뒷자리 숫자 확인
    getLastDigit(num) {
      return Math.abs(num % 10);
    },
    messagePosition(id) {
      if (id == '조직국장' || id == '총괄팀장') {
        return 1;
      } else if (id == '실행위원장') {
        return 2;
      } else if (id == '동대표') {
        return 3;
      } else if (id == '통대표') {
        return 4;
      } else {
        return 5;
      }
    },
  },
  computed: {
    content() {
      this.message = this.message.replace(/(?:\r\n|\r|\n)/g, '<br>');
      // this.message = this.message.replace(/(http[s]?:\/\/[^\s]+)/g, '<a href="$&" style="color:#10FF00; text-decoration: underline;">$&</a>')
      const urls = this.message.match(/(http[s]?:\/\/[\s\S]+)/g);
      if (urls) {
        const cleanedUrls = urls.map((url) => url.replace(/<br>/g, ' <br>'));
        this.message = cleanedUrls[0].replace(
          /(http[s]?:\/\/[^\s]+)/g,
          '<a href="$&" style="color:#10FF00; text-decoration: underline;">$&</a>'
        );
      }
      return this.message;
    },
  },
  mounted() {
    if (this.echo) this.disconnect();
    this.connect();
    document.addEventListener('click', this.documentOption);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.documentOption);
  },
};
